import type {
  GridProps
} from '@chakra-ui/react'
import {
  Button,
  forwardRef,
  Link
} from '@chakra-ui/react'
import { Link as rrdLink } from 'react-router'

import { useApp } from '@/hooks/useApp'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import type { InsuranceParamsPagedQuery } from 'BrokerTsLib/src/dtos'
import { defaultDateFrom } from 'BrokerTsLib/src/dtos'
import { useEffect, useMemo, useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { ConceptsList, getConceptsContext } from '../concepts/ConceptsList'
import { DashboardCard } from './DashboardCard'

export interface DraftsCardProps extends GridProps { }

export const DraftsCard = forwardRef(
  ({ children, ...rest }: DraftsCardProps, ref) => {
    const { user } = useAuth()!
    const { product, currentApp } = useApp()
    const { translate } = useTranslationsContext()

    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(5)
    const [filter, setFilter] = useState<InsuranceParamsPagedQuery>({
      dateCreatedFrom: defaultDateFrom,
      listType: 1,
      pageSize: pageSize,
      pageIndex: 1
    })

    const { data, mutateAsync, isPending } = useGetAll()
    const concepts = data?.data
    const items = concepts?.items ?? []

    useEffect(() => {
      setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
    }, [pageSize, currentPage])

    useEffect(() => {
      if (!user?.id) return

      if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
        mutateAsync(filter)
    }, [filter, product])

    const ctx = useMemo(() => getConceptsContext(product!), [product])


    return (
      <DashboardCard
        ref={ref}
        title={translate('ui.drafts', 'Rozpracované nabídky')}
        // badge={`${items.length} / ${concepts?.totalCount}`}
        {...rest}
      >
        {children}

        <ctx.Provider value={
          {
            loading: isPending,
            totalCount: concepts?.totalCount ?? 0,
            currentPage,
            pageSize,
            filter,
            setCurrentPage,
            setPageSize,
            updateFilter: setFilter,
            reload: () => mutateAsync(filter)
          }
        }>
          <ConceptsList
            concepts={items}
            loading={isPending}
            withPaginator
            leftFooterPart={(
              <Link as={rrdLink} to={`${currentApp?.path?.replace(/\/$/, '')}/concepts`} sx={{ display: 'flex' }}>
                <Button type="button" variant="link" mr={'auto'}>
                  {translate('more', 'Více')}
                </Button>
              </Link>
            )}
          />
        </ctx.Provider>
      </DashboardCard>
    )
  },
)
